import * as React from "react";
import { useState } from 'react';
import { ChevronRight, Notifications, PlayCircle } from "@mui/icons-material";

import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";

import MenuSpeedDial from '../../../atoms/SpeedDial/SpeedDial';

// Multi Select
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";

// Badge
import { Link } from "react-router-dom";
import Router from "../../../../router";

import {
  CustomTableCell,
  ContainerCell,
  FigureHead,
  SectionInfo,
  InfoCell,
  Cell,
  CustomIconButton,
  TableContent,

  ContainerActions,
  ContentCell,
  CustomCheckIcon,

  CustomTableContainer,
  ContainerDiv,
  ContainerItem,
  CustomTableHead,
  PaperContainer,
  CustomTable,
  StickyColumn,
  CustomCell,
} from "./styles";

import { ContainerSpeedDial } from "../../../../styles/GlobalStyle";

//Utils
import { ColorsContext } from "../../../../Context/ColorsContext"
import { FormatDate } from "../../../../utils/formatDate";
import { Icon, Tooltip } from "@mui/material";
import { getIcon } from "../../../../utils/iconConfig";
import { snakeToCamel } from '../../../../utils/commonFunctions/convert';

// Icons
import MapIcon from "@mui/icons-material/Map";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GetAppIcon from "@mui/icons-material/GetApp";
import { ContentCopy, Delete, DownloadDoneRounded } from "@mui/icons-material";
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import { useTranslation } from "react-i18next";
import { useTheme, useMediaQuery, Card, CardContent, Typography, Button, Divider } from "@mui/material";

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from "../../../../Context/PermissionsContext";
import { TableToolbarWorkflow } from "./TableToolbarWorkflow";
import { TableToolbarMyWork } from "./TableToolbarMyWork";
import { useOffline } from "../../../../Context/OfflineContext";

//MUI code
function descendingComparator(a, b, orderBy, customSort) {
  let cond1 = b[orderBy] < a[orderBy]
  let cond2 = b[orderBy] > a[orderBy]

  if (customSort) {
    cond1 = eval(`b.${customSort}`) < eval(`a.${customSort}`)
    cond2 = eval(`b.${customSort}`) > eval(`a.${customSort}`)
    if (eval(`a.${customSort}`) === null) return 1
    if (eval(`b.${customSort}`) === null) return -1
  }

  if (cond1) {
    return -1;
  }
  if (cond2) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy, customSort) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy, customSort)
    : (a, b) => -descendingComparator(a, b, orderBy, customSort);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function TableHeader(props) {
  const { t } = useTranslation();
  const { headCell, order, orderBy, onRequestSort, pageRef, loadData, isCustom } = props;

  const createSortHandler = (property, sortNamePaginated) => (event) => {
    let newOrder = 'asc'; // Valor inicial del orden (primer clic debería ser ascendente)

    if (orderBy === property && order === 'asc') {
      newOrder = 'desc'; // Si ya es ascendente, cambiar a descendente
    } else if (orderBy === property && order === 'desc') {
      newOrder = 'asc'; // Si ya es descendente, cambiar a ascendente
    }

    if (isCustom) {
      pageRef.current.order = sortNamePaginated;
      pageRef.current.sort = newOrder.toUpperCase(); // Actualizar el estado de order en isCustom
    }
    onRequestSort(event, property);

    if (isCustom) loadData({});
  };

  //render column UpdateAt "active"
  const activeColumn = (updatedAt) => {
    let active =  false

    if(updatedAt){
      active = true
    }
    if(orderBy.length > 0){
      active = false
    }
    return active
  }

  return (
    <CustomCell
      key={headCell.id}
      align={headCell.center ? "center" : "left"}
      padding={headCell.disablePadding ? "none" : "normal"}
      sortDirection={orderBy === headCell.id ? order : false}
      dataHead={headCell}
    >
      {headCell.sortArrow == true && (
        <TableSortLabel
          active={orderBy === headCell.id || activeColumn(headCell.orderDesc)}
          direction={orderBy === headCell.id ? order : (headCell.orderDesc ? 'desc' : "asc")}
          onClick={createSortHandler(headCell.id, headCell.sortNamePaginated)}
        >
          {t(headCell.label) || headCell.label}
          {orderBy === headCell.id ? <Box component="span"></Box> : null}
        </TableSortLabel>
      )}
      {headCell.sortArrow == false && (
        <Box component="span">{t(headCell.label) || headCell.label}</Box>
      )}
    </CustomCell>
  );
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, relations, workflow, headers, formColumns, 
    pageRef, loadData, isCustom, isWorkflow, 
    rowsCount, isLotoWorkflow, numSelected, onSelectAllClick } = props;
  const { colors } = React.useContext(ColorsContext);
  const { t } = useTranslation();

  React.useEffect(() => { }, [relations, formColumns]);

  const createSortHandler = (property, customSort) => (event) => {
    onRequestSort(event, property, customSort);
  };

  return (
    <CustomTableHead id="table head">
      <TableRow>
        {isLotoWorkflow &&
          <CustomTableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < props.selectableRowsCount}
              checked={props.selectableRowsCount > 0 && numSelected === props.selectableRowsCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all workflows',
              }}
            />
          </CustomTableCell>
        }
        {headers.map((headCell) => (
          <React.Fragment key={headCell.id}>
            {headCell.id === "relations" ? (
              <React.Fragment>
                {headCell.id === "relations" ?
                  relations?.map((headOptional) => (
                    <CustomTableCell
                      key={"optional-" + headOptional.id}
                      align={"center"}
                      padding={"none"}
                      sx={{
                        padding: "0 16px",
                        color: colors.buttonActionColor,
                        "&:hover": {
                          color: colors.buttonActionColor,
                          opacity: 0.9
                        },
                      }}
                    >
                      <FigureHead>
                        <Icon sx={{ color: colors.buttonActionColor }} fontSize="small">
                          {headOptional.icon}
                        </Icon>
                      </FigureHead>
                    </CustomTableCell>
                  ))
                  :
                  formColumns?.map((headOptional) => (
                    <CustomTableCell
                      key={"optional-" + headOptional.id}
                      align={"center"}
                      padding={"none"}
                      sx={{
                        padding: "0 16px",
                        color: colors.buttonActionColor,
                        "&:hover": {
                          color: colors.buttonActionColor,
                          opacity: 0.9
                        },
                      }}
                    >
                      {headCell.sortArrow === true && (
                        <TableSortLabel
                          active={orderBy === headOptional.id}
                          direction={orderBy === headOptional.id ? order.current : "asc"}
                          onClick={createSortHandler(headOptional.id, headCell.customSort)}
                        >
                          {/* {t(headCell.label) || headCell.label} */}
                          {headOptional['title']}
                          {orderBy === headOptional.id ? <Box component="span"></Box> : null}
                        </TableSortLabel>
                      )}
                    </CustomTableCell>
                  ))
                }
              </React.Fragment>
            ) : (
              <>
                {(isLotoWorkflow && headCell.id === "") && (
                  <CustomCell align="center" padding="normal" dataHead={{ id: 'downloadStatus' }}>
                    <Box component="span">{t("workflow.table.downloaded")}</Box>
                  </CustomCell>
                )}
                {headCell.isOptional ? (
                  <>
                    {workflow?.[headCell.id] && (
                      <TableHeader
                        headCell={headCell}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={(e, value) => onRequestSort(e, value, headCell.customSort)}
                        pageRef={pageRef}
                        loadData={loadData}
                        isCustom={isCustom}
                      />
                    )}
                  </>
                ) : (
                  <TableHeader
                    headCell={headCell}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={(e, value) => onRequestSort(e, value, headCell.customSort)}
                    pageRef={pageRef}
                    loadData={loadData}
                    isCustom={isCustom}
                  />
                )}
              </>
            )}
          </React.Fragment>
        ))}
      </TableRow>
    </CustomTableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const MobileWorkflowCard = ({
  row,
  workflow,
  openPlotPlan,
  handleOpenStatus,
  handleOpenDuplicate,
  handleOpenDelete,
  handleApprove,
  validityTooltip,
  hideBtnCancel,
  fastApproveInstance,
  isLotoWorkflow,
  handleOpenQrScan,
  handleStoreFormForOffline,
  isCustom,
  isSelected,
  handleClick
}) => {
  const { t } = useTranslation();
  const { colors } = React.useContext(ColorsContext);
  const { format } = new FormatDate();
  const ability = useAbility(AbilityContext);
  const { isFormDownloadedForOffline } = useOffline();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const handleOpenMenu = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (event) => {
    if (event) event.stopPropagation();
    setMenuAnchorEl(null);
  };

  return (
    <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
      <CardContent sx={{ position: "relative", pb: "16px !important" }}>
        {/* Row 1: Code and Status */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ color: '#000000', fontWeight: 'bold' }}>
              {row.code !== null ? row.code : row.id}
            </Typography>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            textAlign: 'right', 
            justifyContent: 'flex-end',
            maxWidth: '60%', 
          }}>
            <Box sx={{ display: 'flex', transform: 'scale(0.8)', transformOrigin: 'center', flexShrink: 0 }}>
              {getIcon(row.workflowStatus)}
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Typography sx={{ 
                fontSize: '0.875rem', 
                color: colors.grayFont, 
                lineHeight: 1.2, 
                wordBreak: 'break-word',
                textAlign: 'left'
              }}>
                {(row.workflowStatus?.id >= 0 && t(`workflowManagement.flowState.status.${snakeToCamel(row.workflowStatus?.type)}`)) || row.workflowStatus?.title || ""}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Row 2: Title */}
        {workflow?.hasTitle && row.title && (
          <Box sx={{ mb: 1.5 }}>
            <Typography sx={{ fontSize: '12px', color: '#6c6c6c' }}>
              {t("workflow.table.title")}
            </Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#3b3b3b' }}>
              {row.title}
            </Typography>
          </Box>
        )}

        {/* Row 3: Sitio y Contrato */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: '12px', color: '#6c6c6c' }}>
              {t("workflow.table.plant")}
            </Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#3b3b3b' }}>
              {row.plant?.name || '-'}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, textAlign: 'right' }}>
            <Typography sx={{ fontSize: '12px', color: '#6c6c6c' }}>
              {t("workflow.table.contract")}
            </Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#3b3b3b' }}>
              {row.workflowData?.contract?.code || row.contract?.code || '-'}
            </Typography>
          </Box>
        </Box>

        {/* Row 4: Última actualización y Vigencia */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: '12px', color: '#6c6c6c' }}>
              {t("workflow.table.lastUpdate")}
            </Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#3b3b3b' }}>
              {format({ date: row?.updatedAt, format: true })}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, textAlign: 'right' }}>
            <Typography sx={{ fontSize: '12px', color: '#6c6c6c' }}>
              {t("workflow.table.validity")}
            </Typography>
            {workflow?.hasValidity && row?.validityFrom ? (
              <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#3b3b3b', textAlign: 'right' }}>
                {validityTooltip ? validityTooltip(row?.validityFrom, row?.validityTo) : format({ date: row?.validityFrom, formatWithoutHour: true })}
              </Typography>
            ) : (
              <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#3b3b3b' }}>
                -
              </Typography>
            )}
          </Box>
        </Box>

        <Divider sx={{ mx: -2, my: 1.5 }} />

        {/* Row 5: Descargado */}
        {isLotoWorkflow && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, gap: 1, color: isFormDownloadedForOffline(row.id) ? colors.buttonActionColor : colors.grayDemo }}>
            <DownloadDoneRounded fontSize="small" />
            <Typography sx={{ fontSize: isMobile ? 12 : 14, fontWeight: 'bold' }}>
              {isFormDownloadedForOffline(row.id) ? t("workflow.table.downloaded") : t("workflow.table.notDownloaded")}
            </Typography>
          </Box>
        )}

        {/* Buttons Row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {!isLotoWorkflow && ((workflow?.hasPlotPlan || workflow?.hasPlotPlanNotRequired) && ability.can("PlotPlanList") && ability.can("GetPlotPlan")) && (
              <CustomIconButton
                size="small"
                style={{ backgroundColor: colors.buttonActionColor, color: '#fff' }}
                onClick={(e) => { e.stopPropagation(); openPlotPlan(row); }}
              >
                <MapIcon fontSize="small" />
              </CustomIconButton>
            )}

            {!isLotoWorkflow && (
              <Tooltip title={t("common.actions.process")}>
                <CustomIconButton
                  size="small"
                  style={{ backgroundColor: colors.buttonActionColor, color: '#fff' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenStatus && handleOpenStatus(row, workflow);
                  }}
                >
                  <PlayCircle fontSize="small" />
                </CustomIconButton>
              </Tooltip>
            )}

            {isLotoWorkflow && (
              <>
                <Checkbox
                  color="primary"
                  checked={isSelected}
                  disabled={
                    row.workflowStatus?.statusId === 10002 ||
                    row.workflowStatus?.statusId === 10003
                  }
                  onClick={(event) => {
                    event.stopPropagation();
                    if(handleClick) handleClick(row);
                  }}
                  sx={{ p: 0.5, mr: 0.5 }}
                />
                <Tooltip title={t("common.actions.process")}>
                  <CustomIconButton
                    size="small"
                    style={{ backgroundColor: colors.buttonActionColor, color: '#fff' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (handleOpenQrScan) {
                        handleOpenQrScan(row, workflow);
                      }
                    }}
                  >
                    <PlayCircle fontSize="small" />
                  </CustomIconButton>
                </Tooltip>
              </>
            )}

            {!isLotoWorkflow && (
              <>
                <CustomIconButton
                  size="small"
                  style={{ backgroundColor: '#dbdbdb', color: colors.buttonActionColor }}
                  onClick={handleOpenMenu}
                >
                  <MoreHorizIcon fontSize="small" />
                </CustomIconButton>
                <Menu
                  anchorEl={menuAnchorEl}
                  open={Boolean(menuAnchorEl)}
                  onClose={handleCloseMenu}
                  onClick={handleCloseMenu}
                  transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 0,
                      mb: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                    },
                  }}
                >
                  {ability.can("CloneWorkflowData") &&
                    <MenuItem onClick={(e) => { e.stopPropagation(); handleOpenDuplicate && handleOpenDuplicate(row); handleCloseMenu(); }}>
                      <ListItemIcon>
                        <ContentCopy fontSize="small" style={{ color: colors.buttonActionColor }} />
                      </ListItemIcon>
                      <ListItemText>{t("common.actions.duplicate")}</ListItemText>
                    </MenuItem>
                  }
                  {(ability.can("ApproveWorkflowData") || ability.can("ApproveWorkflowDataCredentials")) &&
                    <MenuItem
                      disabled={!row.isApprove || (fastApproveInstance && fastApproveInstance(row) === false)}
                      onClick={(e) => { e.stopPropagation(); handleApprove && handleApprove(true, row); handleCloseMenu(); }}
                    >
                      <ListItemIcon>
                        <VerifiedOutlinedIcon fontSize="small" style={{ color: colors.buttonActionColor }} />
                      </ListItemIcon>
                      <ListItemText>{t('common.approve')}</ListItemText>
                    </MenuItem>
                  }
                  {(ability.can("ApproveWorkflowData") || ability.can("ApproveWorkflowDataCredentials")) &&
                    <MenuItem
                      disabled={!row.isApprove || (fastApproveInstance && fastApproveInstance(row) === false)}
                      onClick={(e) => { e.stopPropagation(); handleApprove && handleApprove(false, row); handleCloseMenu(); }}
                    >
                      <ListItemIcon>
                        <DisabledByDefaultOutlinedIcon fontSize="small" style={{ color: colors.buttonActionColor }} />
                      </ListItemIcon>
                      <ListItemText>{t('common.reject')}</ListItemText>
                    </MenuItem>
                  }
                  {(ability.can("DeleteWorkflowData") && hideBtnCancel) && [
                    <Divider key="divider" sx={{ borderColor: '#bebfbf', my: 0 }} />,
                    <MenuItem
                      key="delete"
                      disabled={
                        row.workflowStatus?.statusId === 10002 ||
                        row.workflowStatus?.statusId === 10003 ||
                        row.workflowData?.canCancel === false ||
                        row?.canCancel === false
                      }
                      style={{ display: hideBtnCancel ? 'flex' : 'none' }}
                      onClick={(e) => { e.stopPropagation(); handleOpenDelete && handleOpenDelete(row); handleCloseMenu(); }}
                    >
                      <ListItemIcon>
                        <Delete fontSize="small" style={{ color: '#ef4646' }} />
                      </ListItemIcon>
                      <ListItemText sx={{ color: '#ef4646' }}>{t("common.actions.cancel")}</ListItemText>
                    </MenuItem>
                  ]}
                </Menu>
              </>
            )}

            {isLotoWorkflow && (
              <>
                <CustomIconButton
                  size="small"
                  style={{ backgroundColor: '#dbdbdb', color: colors.buttonActionColor }}
                  onClick={handleOpenMenu}
                >
                  <MoreVertIcon fontSize="small" />
                </CustomIconButton>
                <Menu
                  anchorEl={menuAnchorEl}
                  open={Boolean(menuAnchorEl)}
                  onClose={handleCloseMenu}
                  onClick={handleCloseMenu}
                  transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 0,
                      mb: 1.5,
                    },
                  }}
                >
                  <MenuItem onClick={(e) => {
                    e.stopPropagation();
                    if (handleStoreFormForOffline) {
                      handleStoreFormForOffline(row);
                    }
                    handleCloseMenu();
                  }}>
                    <ListItemIcon>
                      <GetAppIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t("lotoWorklow.downloadWorkflow")}</ListItemText>
                  </MenuItem>
                  {(ability.can("DeleteWorkflowData") && hideBtnCancel) && [
                    <Divider key="divider" sx={{ borderColor: '#bebfbf', my: 0 }} />,
                    <MenuItem
                      key="delete"
                      style={{ display: hideBtnCancel ? 'flex' : 'none' }}
                      onClick={(e) => { e.stopPropagation(); handleOpenDelete && handleOpenDelete(row); handleCloseMenu(); }}
                    >
                      <ListItemIcon>
                        <Delete fontSize="small" style={{ color: '#ef4646' }} />
                      </ListItemIcon>
                      <ListItemText sx={{ color: '#ef4646' }}>{t("common.actions.cancel")}</ListItemText>
                    </MenuItem>
                  ]}
                </Menu>
              </>
            )}
          </Box>

          <Box>
            <Link
              to={Router.appWorkflowDetail
                .replace(":workflowId", row.workflowId)
                .replace(":id", row.workflowData?.id || row.id)}
              state={{
                row: row,
                workflow: workflow,
                from: isCustom ? 'workflow' : 'myWork'
              }}
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                endIcon={<ChevronRight fontSize="small" />}
                sx={{ 
                  textTransform: 'none', 
                  backgroundColor: '#eaf4fe',
                  color: '#325073', 
                  fontWeight: 500,
                  fontSize: '12px',
                  boxShadow: 'none',
                  borderRadius: '8px',
                  px: 2,
                  '&:hover': {
                    backgroundColor: '#dcecfc',
                    boxShadow: 'none',
                  }
                }}
              >
                {t("common.actions.viewMore")}
              </Button>
            </Link>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default function TableWorkflow({
  arrayCombined,
  filterPlants,
  filterCompany,
  setFilteredRequest,
  selectedTags,
  setSelectedTags,
  selectedPlants,
  setSelectedPlants,
  filteredRequest,
  rows,
  loading,
  initialDate,
  setInitialDate,
  setFinalDate,
  finalDate,
  handleFilters,
  handleClearDate,
  handleCreateWorkflow,
  handleOpenStatus,
  handleApprove,
  handleOpenDuplicate,
  handleOpenDelete,
  workflow,
  highlightLast,
  relations,
  openPlotPlan,
  headers,
  formColumns,
  setMaintainFilter,
  reloadFilters,
  hideDatesFilter,
  search,
  defaultSort,
  validityTooltip,
  hideFlowBtn,
  hideBtnCancel,
  addDataSpeedDial,
  canceledState,
  closedState,
	rowsCount,
	currentPage,
  pageSize,
  isCustom,
	onChangePage,
  handleChangeSwitch,
  handleChangeFilters,
  handleClearFilters,
  filters,
  setOpenFilterWorkflowModal,
  myWork,
  section,
  pageRef,
  loadData,
  isLotoWorkflow,
  setSelectedRows,
  handleOpenQrScan,
  handleStoreFormForOffline,
  handleDownloadExcel
}) {
  const { t } = useTranslation();
  const { format } = new FormatDate();
  const { colors } = React.useContext(ColorsContext);
  const ability = useAbility(AbilityContext);
  const { isFormDownloadedForOffline } = useOffline();

  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.up("sm"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [customSort, setCustomSort] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [selected, setSelected] = useState([]);
  const [dense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [callFilter, setCallFilter] = React.useState(false);

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [openMenuId, setOpenMenuId] = React.useState(null);

  const handleOpenMenu = (event, id) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setOpenMenuId(id);
  };

  const handleCloseMenu = (event) => {
    if (event) event.stopPropagation();
    setMenuAnchorEl(null);
    setOpenMenuId(null);
  };

  React.useEffect(() => {
    setPage(0);
    if (isCustom) {
      setRowsPerPage(pageSize)
    }
  }, [workflow?.id, headers]);

  React.useEffect(() => {
    if (isCustom) {
      setPage(currentPage);
    }
    else {
      setPage(0);
    }
  }, [filteredRequest]);

  React.useEffect(() => { }, [relations, formColumns]);

  React.useEffect(() => {
    if (defaultSort) {
      handleRequestSort(null, defaultSort, null, 'desc')
    }
  }, [defaultSort]);

  const handleRequestSort = (event, property, property2, defaultOrder) => {
    const isAsc = orderBy === property && order === "asc";
    if (defaultOrder) {
      setOrder(defaultOrder);
    }
    else {
      setOrder(isAsc ? "desc" : "asc");
    }
    setOrderBy(property);
    setCustomSort(property2);
  };

  const handleChangePage = async(_, newPage) => {
    if (isCustom) {
      await onChangePage(newPage, rowsPerPage)
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async(event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (isCustom) {
      await onChangePage(0, event.target.value);
    }
  };

  // Lógica para selección de filas
  const handleClick = (row) => {
    const selectedIndex = selected.indexOf(row.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
    setSelectedRows(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleSelectAllClick = (event) => {
    if (selected.length > 0) {
      setSelected([]);
      setSelectedRows([]);
      return;
    }

    // Excluir de la selección los anulados y cerrados
    const selectableRows = filteredRequest.filter(row => 
      row.workflowStatus?.statusId !== 10002 && 
      row.workflowStatus?.statusId !== 10003
    );
    
    const newSelected = selectableRows.map((n) => n.id);
    setSelected(newSelected);
    setSelectedRows(newSelected);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const fastApproveInstance = (row) => {
    if(section === 'workflow') return row.workflowStatus.canFastApproval
    if(section === 'myWork') return row.workflowData.workflowStatus.canFastApproval
  }

  return (
    <Box sx={{ width: "100%" }}>
        {(isCustom && !loading) &&
          <TableToolbarWorkflow
            isLotoWorkflow={isLotoWorkflow}
            arrayCombined={arrayCombined}
            filterPlants={filterPlants}
            filterCompany={filterCompany}
            hideFlowBtn={hideFlowBtn}
            handleChangeFilters={handleChangeFilters}
            handleFilters={handleFilters}
            filters={filters}
            handleClearFilters={handleClearFilters}
            handleCreateWorkflow={handleCreateWorkflow}
            initialDate={initialDate}
            finalDate={finalDate}
            setOpenFilterWorkflowModal={setOpenFilterWorkflowModal}
            workflow={workflow}
          />
        }

        {(!isCustom && !isLotoWorkflow && !loading) &&
          <TableToolbarMyWork
            arrayCombined={arrayCombined}
            filterPlants={filterPlants}
            rows={rows}
            filteredRequest={filteredRequest}
            setFilteredRequest={setFilteredRequest}
            selectedTags={selectedTags}
            setSelectedTags={setSelectedTags}
            selectedPlants={selectedPlants}
            setSelectedPlants={setSelectedPlants}
            initialDate={initialDate}
            finalDate={finalDate}
            setInitialDate={setInitialDate}
            setFinalDate={setFinalDate}
            handleFilters={handleFilters}
            handleChangeFilters={handleChangeFilters}
            filters={filters}
            handleClearDate={handleClearDate}
            handleCreateWorkflow={handleCreateWorkflow}
            workflow={workflow}
            setMaintainFilter={setMaintainFilter}
            reloadFilters={reloadFilters}
            hideDatesFilter={hideDatesFilter}
            search={search}
            hideFlowBtn={hideFlowBtn}
            canceledState={canceledState}
            closedState={closedState}
            handleChangeSwitch={handleChangeSwitch}
            rowsPerPage={rowsPerPage}
            rowsCount={rowsCount}
            isCustom={isCustom}
            callFilter={callFilter}
            page={page}
            handleDownloadExcel={handleDownloadExcel}
          />
        }
      <PaperContainer sx={{ backgroundColor: isTablet ? undefined : 'transparent', boxShadow: isTablet ? undefined : 'none' }}>
        {!loading && (
          <React.Fragment>
            {isTablet ? (
              <CustomTableContainer isCustom={isCustom} isLotoWorkflow={isLotoWorkflow}>
                <CustomTable stickyHeader
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    relations={relations}
                    workflow={workflow}
                    headers={headers}
                    formColumns={formColumns}
                    pageRef={pageRef}
                    isCustom={isCustom}
                    loadData={loadData}

                    // Selección de filas
                    numSelected={selected.length}
                    onSelectAllClick={handleSelectAllClick}
                    rowsCount={rowsCount}
                    selectableRowsCount={
                      filteredRequest.filter(row => 
                        row.workflowStatus?.statusId !== 10002 && 
                        row.workflowStatus?.statusId !== 10003).length
                    }
                    isLotoWorkflow={isLotoWorkflow}
                  />
                  <TableContent>
                    {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                      rows.sort(getComparator(order, orderBy)).slice() */}
                    {stableSort(filteredRequest, getComparator(order, orderBy, customSort))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.id);

                        return (
                          <TableRow
                            sx={{
                              background:
                                index === 0 && highlightLast
                                  ? "#c3e6fe"
                                  : " none",
                              transition: "2s",
                            }}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            aria-checked={isItemSelected}
                            key={row.id}
                          >
                            {isLotoWorkflow &&
                              <Cell padding="checkbox">
                                <Checkbox
                                  color="primary"
                                  checked={isItemSelected}
                                  disabled={
                                    row.workflowStatus?.statusId === 10002 ||
                                    row.workflowStatus?.statusId === 10003
                                  }
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleClick(row);
                                  }}
                                />
                              </Cell>
                            }

                            <StickyColumn direction="left" className="sticky">
                              <ContainerDiv myWork={myWork}>
                                {myWork &&
                                  <ContainerItem show={row.isNotified}>
                                      {row.isNotified &&
                                        <Notifications color='warning'/>
                                      }
                                  </ContainerItem>
                                }
                                <ContainerItem>
                                  <Link
                                    to={Router.appWorkflowDetail
                                      .replace(":workflowId", row.workflowId)
                                      .replace(":id", row.workflowData?.id || row.id)}
                                    state={{
                                      row: row,
                                      workflow: workflow,
                                      from: isCustom ? 'workflow' : 'myWork'
                                    }}
                                  >
                                    <span style={{ color: colors.detailTextColor }}>
                                      {row.code !== null ? row.code : row.id}
                                    </span>
                                  </Link>
                                </ContainerItem>
                              </ContainerDiv>
                            </StickyColumn>

                            <Cell sx={{ minWidth: 250 }}>
                              <ContainerCell>
                                {getIcon(row.workflowStatus)}
                                <SectionInfo>
                                  <InfoCell>
                                    <p style={{ fontSize: '0.875rem', color: colors.grayFont }}>
                                      {(row.workflowStatus?.id >= 0 && t(`workflowManagement.flowState.status.${snakeToCamel(row.workflowStatus?.type)}`)) || ""}
                                    </p>
                                  </InfoCell>
                                  <InfoCell>
                                    {row.workflowStatus?.title || ""}
                                  </InfoCell>
                                </SectionInfo>
                              </ContainerCell>
                            </Cell>

                            {workflow?.hasTitle && 
                              <Cell sx={{ minWidth: 200 }}>
                                {row.title || ""}
                              </Cell>
                            }
                            <Cell sx={{ minWidth: 200 }}>{row.plant?.name}</Cell>

                            {workflow?.hasValidity && (
                              <Tooltip title={validityTooltip(row?.validityFrom, row?.validityTo)}>
                                <Cell>
                                  <ContainerCell>
                                    <SectionInfo>
                                      {row?.validityFrom && (
                                        <InfoCell>
                                          <div>
                                            {format({ date: row?.validityFrom, formatWithoutHour: true })}
                                          </div>
                                        </InfoCell>
                                      )}
                                    </SectionInfo>
                                  </ContainerCell>
                                </Cell>
                              </Tooltip>
                            )}

                            <Cell>
                              <ContentCell>
                                {format({ date: row?.updatedAt, format: true })}
                              </ContentCell>
                            </Cell>
                            {row?.formColumn?.map((column, index) => (
                              <React.Fragment key={"formColumn-" + index}>
                                <Cell align="center">{column['value'] ?? ''}</Cell>
                              </React.Fragment>
                            ))}
                            {((workflow?.hasPlotPlan || workflow?.hasPlotPlanNotRequired) && ability.can("PlotPlanList") && ability.can("GetPlotPlan")) && (
                              <Cell>
                                <CustomIconButton
                                  size="small"
                                  style={{ backgroundColor: colors.buttonActionColor, color: '#fff' }}
                                  onClick={() => openPlotPlan(row)}
                                >
                                  <MapIcon />
                                </CustomIconButton>
                              </Cell>
                            )}

                            {isLotoWorkflow && (
                               <Cell align="left">
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, color: isFormDownloadedForOffline(row.id) ? colors.buttonActionColor : colors.grayDemo }}>
                                    <DownloadDoneRounded fontSize="small" />
                                    <span style={{ fontSize: isMobile ? 12 : 14, fontWeight: 500 }}>
                                      {isFormDownloadedForOffline(row.id) ? t("workflow.table.downloaded") : t("workflow.table.notDownloaded")}
                                    </span>
                                  </Box>
                               </Cell>
                            )}

                            <StickyColumn direction="right" >

                              {/* Actions component for mobile dimension  */}
                              <ContainerSpeedDial>
                                <MenuSpeedDial
                                  options={addDataSpeedDial(row, workflow)}
                                />
                              </ContainerSpeedDial>

                              {/* Default render actions table */}
                              {!isLotoWorkflow &&
                                <ContainerActions>
                                  <div>
                                    <Tooltip title={t("common.actions.process")}>
                                      <CustomIconButton
                                        size="small"
                                        style={{ 
                                          backgroundColor: colors.buttonActionColor, 
                                          color: '#fff',
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleOpenStatus(row, workflow);
                                        }}
                                      >
                                        <PlayCircle />
                                      </CustomIconButton>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <CustomIconButton
                                      size="small"
                                      style={{ 
                                        backgroundColor: '#dbdbdb', 
                                        color: colors.buttonActionColor, 
                                        marginLeft: '8px' 
                                      }}
                                      onClick={(e) => handleOpenMenu(e, row.id)}
                                    >
                                      <MoreHorizIcon />
                                    </CustomIconButton>
                                    <Menu
                                      anchorEl={menuAnchorEl}
                                      open={openMenuId === row.id}
                                      onClose={handleCloseMenu}
                                      onClick={handleCloseMenu}
                                      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                      PaperProps={{
                                        elevation: 0,
                                        sx: {
                                          overflow: 'visible',
                                          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                          mt: 1.5,
                                          '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                          },
                                          '&:before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                          },
                                        },
                                      }}
                                    >
                                      {ability.can("CloneWorkflowData") &&
                                        <MenuItem onClick={(e) => { e.stopPropagation(); handleOpenDuplicate(row); handleCloseMenu(); }}>
                                          <ListItemIcon>
                                            <ContentCopy fontSize="small" style={{ color: colors.buttonActionColor }} />
                                          </ListItemIcon>
                                          <ListItemText>{t("common.actions.duplicate")}</ListItemText>
                                        </MenuItem>
                                      }
                                      {(ability.can("ApproveWorkflowData") || ability.can("ApproveWorkflowDataCredentials")) &&
                                        <MenuItem
                                          disabled={!row.isApprove || (fastApproveInstance(row) === false)}
                                          onClick={(e) => { e.stopPropagation(); handleApprove(true, row); handleCloseMenu(); }}
                                        >
                                          <ListItemIcon>
                                            <VerifiedOutlinedIcon fontSize="small" style={{ color: colors.buttonActionColor }} />
                                          </ListItemIcon>
                                          <ListItemText>{t('common.approve')}</ListItemText>
                                        </MenuItem>
                                      }
                                      {(ability.can("ApproveWorkflowData") || ability.can("ApproveWorkflowDataCredentials")) &&
                                        <MenuItem
                                          disabled={!row.isApprove || (fastApproveInstance(row) === false)}
                                          onClick={(e) => { e.stopPropagation(); handleApprove(false, row); handleCloseMenu(); }}
                                        >
                                          <ListItemIcon>
                                            <DisabledByDefaultOutlinedIcon fontSize="small" style={{ color: colors.buttonActionColor }} />
                                          </ListItemIcon>
                                          <ListItemText>{t('common.reject')}</ListItemText>
                                        </MenuItem>
                                      }
                                      {(ability.can("DeleteWorkflowData") && hideBtnCancel) && [
                                        <Divider key="divider" sx={{ borderColor: '#bebfbf', my: 0 }} />,
                                        <MenuItem
                                          key="delete"
                                          disabled={
                                            row.workflowStatus?.statusId === 10002 ||
                                            row.workflowStatus?.statusId === 10003 ||
                                            row.workflowData?.canCancel === false ||
                                            row?.canCancel === false
                                          }
                                          style={{ display: hideBtnCancel ? 'flex' : 'none' }}
                                          onClick={(e) => { e.stopPropagation(); handleOpenDelete(row); handleCloseMenu(); }}
                                        >
                                          <ListItemIcon>
                                            <Delete fontSize="small" style={{ color: '#ef4646' }} />
                                          </ListItemIcon>
                                          <ListItemText sx={{ color: '#ef4646' }}>{t("common.actions.cancel")}</ListItemText>
                                        </MenuItem>
                                      ]}
                                    </Menu>
                                  </div>
                                </ContainerActions>
                              }
                              {isLotoWorkflow &&
                                <ContainerActions>
                                  <div>
                                    <Tooltip title={t("common.actions.process")}>
                                      <CustomIconButton
                                        size="small"
                                        style={{ backgroundColor: colors.buttonActionColor, color: '#fff' }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (handleOpenQrScan) {
                                            handleOpenQrScan(row, workflow);
                                          }
                                        }}
                                      >
                                        <PlayCircle fontSize="small" />
                                      </CustomIconButton>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <CustomIconButton
                                      size="small"
                                      style={{ backgroundColor: '#dbdbdb', color: colors.buttonActionColor, marginLeft: '8px' }}
                                      onClick={(e) => handleOpenMenu(e, row.id)}
                                    >
                                      <MoreVertIcon fontSize="small" />
                                    </CustomIconButton>
                                    <Menu
                                      anchorEl={menuAnchorEl}
                                      open={openMenuId === row.id}
                                      onClose={handleCloseMenu}
                                      onClick={handleCloseMenu}
                                      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                      PaperProps={{
                                        elevation: 0,
                                        sx: {
                                          overflow: 'visible',
                                          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                          mt: 1.5,
                                          '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                          },
                                          '&:before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                          },
                                        },
                                      }}
                                    >
                                      <MenuItem onClick={(e) => {
                                        e.stopPropagation();
                                        if (handleStoreFormForOffline) {
                                          handleStoreFormForOffline(row);
                                        }
                                        handleCloseMenu();
                                      }}>
                                        <ListItemIcon>
                                          <GetAppIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText>{t("lotoWorklow.downloadWorkflow")}</ListItemText>
                                      </MenuItem>
                                      {(ability.can("DeleteWorkflowData") && hideBtnCancel) && [
                                        <Divider key="divider" sx={{ borderColor: '#bebfbf', my: 0 }} />,
                                        <MenuItem
                                          key="delete"
                                          style={{ display: hideBtnCancel ? 'flex' : 'none' }}
                                          onClick={(e) => { e.stopPropagation(); handleOpenDelete(row); handleCloseMenu(); }}
                                        >
                                          <ListItemIcon>
                                            <Delete fontSize="small" style={{ color: '#ef4646' }} />
                                          </ListItemIcon>
                                          <ListItemText sx={{ color: '#ef4646' }}>{t("common.actions.cancel")}</ListItemText>
                                        </MenuItem>
                                      ]}
                                    </Menu>
                                  </div>
                                </ContainerActions>
                              }
                            </StickyColumn>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableContent>
                </CustomTable>
              </CustomTableContainer>
            ) : (
              <Box sx={{ pb: 2, px: 0, display: "flex", flexDirection: "column", gap: 2 }}>
                <Divider/>
                {stableSort(filteredRequest, getComparator(order, orderBy, customSort))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <MobileWorkflowCard
                      key={row.id}
                      row={row}
                      workflow={workflow}
                      openPlotPlan={openPlotPlan}
                      handleOpenStatus={handleOpenStatus}
                      handleOpenDuplicate={handleOpenDuplicate}
                      handleOpenDelete={handleOpenDelete}
                      handleApprove={handleApprove}
                      validityTooltip={validityTooltip}
                      hideBtnCancel={hideBtnCancel}
                      fastApproveInstance={fastApproveInstance}
                      addDataSpeedDial={addDataSpeedDial}
                      isLotoWorkflow={isLotoWorkflow}
                      handleOpenQrScan={handleOpenQrScan}
                      handleStoreFormForOffline={handleStoreFormForOffline}
                      isCustom={isCustom}
                      isSelected={isSelected(row.id)}
                      handleClick={handleClick}
                    />
                  ))}
                {filteredRequest.length === 0 && (
                  <Typography align="center" color="textSecondary">{t("common.empty.noData")}</Typography>
                )}
              </Box>
            )}
            
            <Box
              sx={{
                position: isTablet ? 'static' : 'fixed',
                bottom: isTablet ? 'auto' : '18px',
                left: 0,
                right: 0,
                backgroundColor: 'background.paper',
                borderTop: "1px solid " + colors.gray,
                zIndex: 1100,
                boxShadow: isTablet ? 'none' : '0px -2px 10px rgba(0,0,0,0.1)',
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rowsCount}
                rowsPerPage={rowsPerPage}
                showFirstButton={true}
                showLastButton={isCustom ? false : true}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={t("common.itemsPerPage")}
                labelDisplayedRows={({ from, to, count }) => {
                  return "" + from + "-" + to + ` ${t("common.of")} ` + count;
                }}
              />
            </Box>
          </React.Fragment>
        )}
      </PaperContainer>
      {/*
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
      */}
    </Box>
  );
}




